<template>
  <footer id="lid-footer" class="relative">
    <section v-if="footer.length" class="pt-8 pb-5 sm:py-8 bg-white border-b-4 border-white px-4 lg:px-6 xl:px-12">
      <ul class="flex flex-col gap-10 sm:gap-y-8 mx-auto sm:grid grid-cols-2 lg:grid-cols-12 lg:gap-x-8 xl:gap-x-12">
        <li
          v-for="(menu, index) in footer"
          :key="index"
          :class="{ 'sm:col-span-1 lg:col-span-3 2xl:col-span-2': index > 0, 'sm:col-span-2 lg:col-span-6 2xl:col-span-6 2xl:col-start-2': index === 0 }"
        >
          <h3 class="mb-4 font-bold leading-4">{{ menu.title }}</h3>
          <ul>
            <template v-for="(child, childKey) in menu.children">
              <li v-if="child.url" :key="childKey">
                <AtomLink :title="child.title" :url="child.url">
                  {{ child.title }}
                </AtomLink>
              </li>
            </template>
          </ul>

          <template v-if="index === 0 && site === 'inspectiedienst'">
            <ul class="flex gap-2 xl:gap-6 items-center flex-wrap sm:flex-nowrap">
              <li class="flex-1 sm:flex-initial">
                <a
                  href="https://www.rijksoverheid.nl/ministeries/ministerie-van-landbouw-visserij-voedselzekerheid-en-natuur"
                  title="Ministerie van Landbouw, Visserij, Voedselzekerheid en Natuur"
                  target="_blank"
                >
                  <img class="border-solid border-app-gray-silverstone" src="/images/logos/Min_LVVN_Logo.png" :alt="t_('logo-lvvn')" />
                </a>
              </li>
              <li class="flex-1 sm:flex-initial">
                <a href="https://www.rijksoverheid.nl/ministeries/ministerie-van-justitie-en-veiligheid" title="Ministerie van Justitie en Veiligheid" target="_blank">
                  <img class="border-solid border-app-gray-silverstone" src="/images/logos/Min_JV_Logo.png" :alt="t_('logo-jv')" />
                </a>
              </li>
              <li class="w-full">
                <a href="https://www.dierenbescherming.nl/" title="Dierenbescherming.nl" target="_blank">
                  <AtomBrandLogoDesktop class="h-12 lg:h-10 xl:h-12 pointer-events-none" />
                </a>
              </li>
            </ul>
          </template>

          <template v-if="index === 1 && site === 'inspectiedienst'">
            <p class="my-4">{{ t_('follow-us') }}</p>
            <MoleculeLidFooterSocialMedia />
          </template>
        </li>
      </ul>
    </section>
    <section v-if="bottom.length" class="flex py-6 text-xs bg-transparent md:text-base px-4 lg:px-6 xl:px-12">
      <div class="flex items-center md:justify-end gap-8 sm:gap-12 2xl:gap-32 w-full">
        <AtomLink v-for="(item, index) in bottom" :key="index" :url="item.url" class="hover:underline cursor-pointer">{{ item.title }}</AtomLink>
      </div>
    </section>
  </footer>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useNavigationStore } from '~/store/navigation'
import { setupSiteConfig } from '~/composables/craft'
import { setupTranslationPrefixer } from '~/composables/util'

const navigationStore = useNavigationStore()
const { site } = setupSiteConfig()
const { t_ } = setupTranslationPrefixer('lid-footer')

const bottom = computed(() => navigationStore.bottom)
const footer = computed(() => navigationStore.footer)
</script>
